import { getCssCustomProperty } from '../../../../../../../../shared/helpers/get-css-custom-property';

type ColorScheme = {
    containerBackground: string;
    textPrimary: string;
    iconMuted: string;
    iconHand: string;
    iconSummarization: string;
    iconRecording: string;
    iconWaitingRoom: string;
    dtmfCircleBackground: string;
    dtmfCircleText: string;
    separator: string;
};

/**
 * Кэш цветов из CSS-переменных.
 * Если при первом вызове переменные недоступны — следующий вызов попробует получить их снова.
 * При добавлении поддержки динамической смены темы — добавить инвалидацию.
 */
let cachedColors: ColorScheme | null = null;

function hasEmptyValues(colors: ColorScheme): boolean {
    return Object.values(colors).some((value) => !value);
}

/**
 * Возвращает цвета из CSS-переменных.
 * Если в кэше есть пустые значения — пробует получить заново.
 */
export function getColors(): ColorScheme {
    // Если кэш есть И все значения валидны — возвращаем
    if (cachedColors && !hasEmptyValues(cachedColors)) {
        return cachedColors;
    }

    cachedColors = {
        containerBackground: getCssCustomProperty('--orb-color-cool-gray-1100'),
        textPrimary: getCssCustomProperty('--orb-color-cool-gray-50'),
        iconMuted: getCssCustomProperty('--orb-color-cool-gray-600'),
        iconHand: getCssCustomProperty('--orb-color-amber-500'),
        iconSummarization: getCssCustomProperty('--orb-color-orange-500'),
        iconRecording: getCssCustomProperty('--orb-color-red-400'),
        iconWaitingRoom: getCssCustomProperty('--orb-color-cool-gray-600'),
        dtmfCircleBackground: getCssCustomProperty('--orb-color-cool-gray-50'),
        dtmfCircleText: getCssCustomProperty('--orb-color-cool-gray-1100'),
        separator: getCssCustomProperty('--orb-color-cool-gray-alpha-200'),
    };

    return cachedColors;
}
